import { Component } from '@angular/core';
import { inject } from '@angular/core';
import { AutosaveService } from '../autosave.service';

@Component({
  selector: 'app-autosave-indicator',
  templateUrl: './autosave-indicator.component.html',
  styleUrls: ['./autosave-indicator.component.scss'],
  standalone: false
})

export class AutosaveIndicatorComponent {
  state$ = inject(AutosaveService).state$;
}
